import { SimpleSidebar } from "@volca/ui/components/ui/simple-sidebar";
import type { IReferral, ReferralUpdateParams } from "./referral";
import type { ReferralColumn } from "./referral";
import { KanbanSidebar } from "./referral-kanban-view/kanban-sidebar";
import { TableSidebar } from "./referral-table-view/table-sidebar";

interface ReferralsSidebarProps {
  referral: IReferral | null;
  viewType: "kanban" | "table";
  onClose: () => void;
  onUpdate: (values: Partial<ReferralUpdateParams>) => void;
  onNextColumn: (column: ReferralColumn, referral: IReferral) => void;
  onLost: () => void;
  onPayout: () => void;
  onDelete: () => void;
}

export const ReferralsSidebar = ({
  referral,
  viewType,
  onClose,
  onUpdate,
  onNextColumn,
  onLost,
  onPayout,
  onDelete,
}: ReferralsSidebarProps) => {
  if (!referral) return null;

  if (viewType === "kanban") {
    return (
      <KanbanSidebar
        referral={referral}
        onClose={onClose}
        onUpdate={onUpdate}
        onNextColumn={onNextColumn}
        onLost={onLost}
        onPayout={onPayout}
        onDelete={onDelete}
      />
    );
  }

  return (
    <SimpleSidebar data-cy="referrals-sidebar">
      <TableSidebar
        referral={referral}
        onClose={onClose}
        onUpdate={onUpdate}
        onLost={onLost}
        onPayout={onPayout}
        onDelete={onDelete}
      />
    </SimpleSidebar>
  );
};
